var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestIconModal = function SvgRequestIconModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#F0B51A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.233 13.17v-2.776a.234.234 0 0 0-.468 0v4.29l.575-.767a8.208 8.208 0 0 1 6.578-3.29l-6.685 2.543Zm0 0 .891-.797m-.89.797.89-.797m0 0a8.689 8.689 0 1 1-2.896 6.476.234.234 0 1 1 .468 0 8.221 8.221 0 1 0 8.222-8.221l-5.793 1.745Zm-1.359 2.633v-.234h3.309a.234.234 0 0 1 0 .468h-3.075a.234.234 0 0 1-.234-.234Zm6.62 3.843v.535h2.84c.062 0 .121.024.165.068l.378-.378-.378.378a.234.234 0 0 1-.165.4H19.15a.234.234 0 0 1-.234-.234v-4.612a.234.234 0 1 1 .468 0v3.843Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.069
  })));
};
export default SvgRequestIconModal;